/**
 * Minimal fixed header — template style: tiny wordmark, two quiet actions.
 * Auth-aware via the app AuthContext (Supabase).
 */
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function MinimalHeader() {
  const { isSignedIn, signOut } = useAuth();

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div className="flex items-center justify-between px-6 py-5 md:px-12">
        <Link
          to="/"
          className="whitespace-nowrap rounded-full bg-white/70 px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.16em] text-neutral-900 backdrop-blur-md sm:px-4 sm:text-xs sm:tracking-[0.2em]"
        >
          Jesus Entered the Chat
        </Link>
        <nav className="flex items-center gap-3 rounded-full bg-white/70 px-3 py-2 backdrop-blur-md sm:gap-4 sm:px-4">
          <Link to="/#features" className="hidden text-sm text-neutral-500 transition hover:text-neutral-900 sm:block">
            Features
          </Link>
          <Link to="/storyboard" className="hidden text-sm text-neutral-500 transition hover:text-neutral-900 sm:block">
            Storyboard
          </Link>
          <Link to="/waitlist" className="hidden text-sm text-neutral-500 transition hover:text-neutral-900 sm:block">
            Waitlist
          </Link>
          <Link to="/download" className="text-sm text-neutral-500 transition hover:text-neutral-900">
            Install
          </Link>
          {isSignedIn ? (
            <>
              <Link to="/chat" className="text-sm text-neutral-500 transition hover:text-neutral-900">
                Chat
              </Link>
              <button
                onClick={() => void signOut()}
                className="text-sm text-neutral-500 transition hover:text-neutral-900"
              >
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link to="/sign-in" className="hidden text-sm text-neutral-500 transition hover:text-neutral-900 sm:block">
                Sign in
              </Link>
              <Link
                to="/waitlist"
                className="rounded-full bg-neutral-900 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-neutral-700"
              >
                Join waitlist
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
